<template>
    <div class="container">
        <div class="head_bg">
            <common-head></common-head>
            <div class="head_content">
                <div>
                    <p>联系我们</p>
                    <div></div>
                </div>
            </div>
        </div>
        <div class="bg_c_w">
            <div class="body_content">
                <h1>联系方式</h1>
                <p>地址：杭州市江干区普盛巷9号东谷创业园8-9层</p>
                <p>电话：0571-56638136</p>
                <p>邮箱：support@duomai.com</p>
                <p>公交：357/358三村社区东公交站</p>
                <p>地铁方式：地铁1号线（文泽路方向），在九和路站B1出口向前1.7公里</p>
            </div>
            <div class="body_content">
                <h1>微信关注我们</h1>
                <div class="body_content_qrcode">
                    <div>
                        <img src="../assets/images/vx_duomai.png" alt="">
                        <p>多麦股份</p>
                    </div>
                    <div>
                        <img src="../assets/images/vx_mlh.png" alt="">
                        <p>麦乐会</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="map">
            <el-amap vid="amapDemo" :zoom="zoom" :center="center">
                <el-amap-info-window :position="mywindow.position" :content="mywindow.content" :visible="mywindow.visible" :events="mywindow.events"></el-amap-info-window>
                <el-amap-marker :position="marker.position" :events="marker.events" :visible="marker.visible" :draggable="marker.draggable"></el-amap-marker>
            </el-amap>
        </div>
        <common-footer></common-footer>
    </div>
</template>

<script>
import commonHead from '../components/common-head.vue'
import commonFooter from '../components/common-footer.vue'
export default {
    data() {
        return {
            zoom: 16,
            center: [120.25188, 30.31858],
            marker: {
                position: [120.25188, 30.31858],
                visible: true,
                draggable: true
            },
            mywindow: {
                position: [120.25188, 30.31858],
                content:
                    '<h4 style="font-size: 13px;">地址：杭州市江干区普盛巷9号东谷创业园8-9层</h4>' +
                    '<div style="font-size: 13px;">电话：0571-56638596</div>' +
                    '<div style="font-size: 13px;">邮箱：support@duomai.com</div>' +
                    '<div style="font-size: 13px;">公交：357/358三村社区东公交站</div>' +
                    '<div style="font-size: 13px;">地铁方式：地铁1号线（文泽路方向），在九和路站B1出口向前1.7公里</div>',
                visible: true
            },
            plugin: {
                pName: "Scale",
                events: {
                    init(instance) {
                        console.log(instance);
                    }
                }
            }
        }
    },
    components: {
        commonHead,
        commonFooter
    },
}
</script>

<style lang="less" scoped>
.head_bg {
    background-image: url("../assets/images/banner_con.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    & .head_content {
        height: 95px;
        position: relative;
        & > div {
            position: absolute;
            top: 41px;
            left: 20px;
            & > p {
                font-size: 20px;
                color: #ffffff;
                margin-bottom: 3.5px;
            }
            & > div {
                width: 40px;
                height: 2px;
                background-color: #fff;
            }
        }
    }
}
.bg_c_w {
    padding: 36px 20px 46px;
    & .body_content {
        & h1 {
            margin-bottom: 24px;
        }
        & p {
            font-size: 12px;
            color: #666666;
            letter-spacing: 0;
            line-height: 20px;
        }
        & .body_content_qrcode {
            display: flex;
            & > div {
                width: 65px;
                & img {
                    width: 65px;
                    height: 65px;
                    display: block;
                    margin-bottom: 4px;
                }
                & > p {
                    font-size: 12px;
                    color: #666666;
                    letter-spacing: 0;
                    line-height: 16px;
                    text-align: center;
                }
            }
            & > div:first-child {
                margin-right: 20px;
            }
        }
    }
    & .body_content:first-child {
        margin-bottom: 46px;
    }
}

.map {
    width: 100%;
    height: 250px;
}
</style>